<ng-container>
    <button 
        *ngIf="buttonType() === 'modal-exit'"
        class="btn-close"
        [ngClass]="{'modal-exit': buttonType() === 'modal-exit'}" 
        (click)="close()">
        <span>
            Close
        </span>
        <lib-icon [icon]="closeIcon" class="icon"></lib-icon>
    </button>

    <button 
        *ngIf="buttonType() === 'notifaction-modal-exit'"
        class="btn-notifaction-close"
        [ngClass]="{'notifaction-exit': buttonType() === 'notifaction-exit'}" 
        (click)="close()">
        <lib-icon [icon]="closeIcon" class="icon"></lib-icon>
    </button>

    <button 
        *ngIf="buttonType() === 'snackbar-exit'"
        class="btn-close"
        (click)="closeSnackbar()"
        >
        <lib-icon [icon]="closeIcon" class="icon"></lib-icon>
    </button>
</ng-container>
    

